import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgStarMagicGlow = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m8.617 6.837 2.976 1.107a.95.95 0 0 0 .88-.114l2.637-1.835a.94.94 0 0 1 1.486.817l-.174 3.184a.94.94 0 0 0 .37.799l2.525 1.91a.956.956 0 0 1-.337 1.676l-3.081.861a.97.97 0 0 0-.652.608l-1.073 3.018a.957.957 0 0 1-1.215.59.95.95 0 0 1-.48-.371l-1.73-2.653a.94.94 0 0 0-.774-.423l-3.19-.045a.942.942 0 0 1-.71-1.54l2.012-2.503a.96.96 0 0 0 .175-.87l-.897-3.049a.963.963 0 0 1 1.252-1.167"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m19.686 8.956.901-.295M11.588 3v1.361zm-6.953 8.315h-1.22zm4.686 7.964-.316.965zM18.297 18.613 20.524 21"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgStarMagicGlow);
export default ForwardRef;
